import React from 'react';
import LmsLookupDefinitionsPage from '../lookup-definitions/LmsLookupDefinitionsPage';

// Araç Modelleri (VEHICLE_MODEL groupCode'u), bkz. docs/LMS-Arac-Modelleri.md.
// Eğitim Tipi/Lokasyonu'ndan iki noktada farklılaşıyor:
// - `code` alanı burada anlamlı ve zorunlu (Eğitim Kataloğu'ndaki vehicleModel alanı ile
//   eğitim adı formülü bu koddan besleniyor — bkz. [[project_lms_module]] Pass 6), bu yüzden
//   `showCodeField` açık (oluşturmada girilir, düzenlemede değiştirilemez/disabled).
// - Doc'ta hard delete ucu yok; kayıtlar "Pasife Çekme"/"Aktife Alma" (Update ile isActive)
//   üzerinden yönetiliyor, bu yüzden `allowDelete={false}` ve `showActiveField` açık.
const VehicleModelDefinitions = () => (
    <LmsLookupDefinitionsPage groupCode="VEHICLE_MODEL" pageTitleKey="vehicleModelDefinitions.title" allowDelete={false} showCodeField showSortField showActiveField />
);

export default VehicleModelDefinitions;
